// extracted by mini-css-extract-plugin
module.exports = {"image":"image--Explicit-paywalls-components__1XwvP","description":"description--Explicit-paywalls-components__9pkAq"};